const PageFileRecovery = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/operatormanager/filerecovery/PageFileRecovery')
const PageTaskDelegate = () => import(/* webpackChunkName: "page-workflow" */ '@/modules/operatormanager/taskdelegate/PageTaskDelegate')

export default [
  {
    path: '/PageFileRecovery',
    name: 'PageFileRecovery',
    component: PageFileRecovery,
    meta: {
      title: '办件回收',
    },
  },

  {
    path: '/PageTaskDelegate',
    name: 'PageTaskDelegate',
    component: PageTaskDelegate,
    meta: {
      title: '任务委托',
    },
  },

]
